

















































































import mixins from 'vue-typed-mixins'
import {
  LocationType,
  Location,
  LocationDistrict,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import localityPicker, {
  AutocompleteObject,
} from '@/mixins/valuation/localityPicker'
import { HouseNumberCMService } from '@/services/location/houseNumberCM'
import { IdValueObject, ValidatedResponse } from '@/interfaces/app/ValueObjects'
import { LocalityValuationStepData } from '@/interfaces/valuation/ValuationData'
import { getNestedValue } from '@/util/helpers'

export default mixins(localityPicker).extend({
  name: `${LocationType.District}-picker`,
  created() {
    if (this.locationData) {
      this.cachedLocationData = JSON.parse(JSON.stringify(this.locationData))
    }
    this.region.loading = true
    this.districtLocationService
      .getRegions()
      .then(regions => {
        this.region.items = regions as IdValueObject[]
        const cachedId = getNestedValue(this.cachedLocationData, [
          'locationCadastralRegionId',
        ])
        if (cachedId && this.region.items.find(i => i.id === cachedId)) {
          this.region.id = cachedId
        }
      })
      .finally(() => (this.region.loading = false))
  },
  data(): {
    region: AutocompleteObject
    district: AutocompleteObject
    cadastralArea: AutocompleteObject
    houseNumber: AutocompleteObject
    cachedLocationData: LocationDistrict | undefined
  } {
    return {
      region: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      district: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      cadastralArea: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      houseNumber: {
        id: undefined,
        search: '',
        items: [],
        loading: false,
      },
      cachedLocationData: undefined,
    }
  },
  computed: {
    locationData(): LocationDistrict | undefined {
      const stepData = this.$store.getters['valuationProcess/currentStepData']
      if (stepData.location) {
        return stepData.location as LocationDistrict
      }
    },
    districtLocationService(): HouseNumberCMService {
      return this.locationService as HouseNumberCMService
    },
    location(): ValidatedResponse<LocationDistrict> {
      if (
        !this.region.id ||
        !this.region.search ||
        !this.district.id ||
        !this.district.search ||
        !this.cadastralArea.id ||
        !this.cadastralArea.search ||
        !this.houseNumber.id ||
        !this.houseNumber.search
      ) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          locationCadastralRegion: this.region.search,
          locationCadastralRegionId: this.region.id,
          locationCadastralDistrict: this.district.search,
          locationCadastralDistrictId: this.district.id,
          locationCadastralArea: this.cadastralArea.search,
          locationCadastralAreaId: this.cadastralArea.id,
          locationHouseNumber: this.houseNumber.search,
          locationHouseNumberId: this.houseNumber.id,
        },
      }
    },
  },
  methods: {
    resetCadastralDistrict() {
      this.district.id = undefined
      this.district.search = ''
    },
    resetCadastralArea() {
      this.cadastralArea.id = undefined
      this.cadastralArea.search = ''
    },
    resetHouseNumber() {
      this.houseNumber.id = undefined
      this.houseNumber.search = ''
    },
  },
  watch: {
    'region.id'(value: number | undefined) {
      this.resetHouseNumber()
      this.resetCadastralArea()
      this.resetCadastralDistrict()

      if (!value) {
        return
      }
      this.district.loading = true
      this.districtLocationService
        .getDistricts(value)
        .then(districts => {
          this.district.items = districts as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationCadastralDistrictId',
          ])
          if (cachedId && this.district.items.find(i => i.id === cachedId)) {
            this.district.id = cachedId
          }
        })
        .finally(() => (this.district.loading = false))
    },
    'district.id'(value: number | undefined) {
      this.resetHouseNumber()
      this.resetCadastralArea()

      if (!value) {
        return
      }
      this.cadastralArea.loading = true
      this.districtLocationService
        .getCadastralAreas(value)
        .then(cadastralAreas => {
          this.cadastralArea.items = cadastralAreas as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationCadastralAreaId',
          ])
          if (
            cachedId &&
            this.cadastralArea.items.find(i => i.id === cachedId)
          ) {
            this.cadastralArea.id = cachedId
          }
        })
        .finally(() => (this.cadastralArea.loading = false))
    },
    'cadastralArea.id'(value: number | undefined) {
      this.resetHouseNumber()
      if (!value) {
        return
      }
      this.houseNumber.loading = true
      this.districtLocationService
        .getHouseNumbers(value)
        .then(houseNumbers => {
          this.houseNumber.items = houseNumbers as IdValueObject[]
          const cachedId = getNestedValue(this.cachedLocationData, [
            'locationHouseNumber',
          ])
          if (cachedId && this.houseNumber.items.find(i => i.id === cachedId)) {
            this.houseNumber.id = cachedId
          }
        })
        .finally(() => (this.houseNumber.loading = false))
    },
  },
})
